import { apiClient } from "@base/api/client";
import type { EligiblePlansResponse } from "@features/membership/model/types";

/**
 * GET /82office/membership/api/upgrade (query params 없음)
 * 멤버십 업그레이드 가능 플랜 조회 (현재 플랜 기준으로 업그레이드 가능한 플랜 목록)
 *
 * ※ 동일 엔드포인트가 params 유무에 따라 다른 응답을 반환함.
 *   - params 없음 → 이 함수 (EligiblePlansResponse)
 *   - upgrade_type 있음 → fetchUpgradeCalculation (UpgradeCalculation)
 *
 * Error: NO_RUNNING_MEMBERSHIP - No running membership found. (Subscription이 없는 회사)
 */
export async function fetchEligiblePlans(): Promise<EligiblePlansResponse> {
  const { data } = await apiClient.get<EligiblePlansResponse>("/82office/membership/api/upgrade");
  return data;
}

/*
 * TanStack Query 사용 예시:
 *
 * import { useQuery } from "@tanstack/react-query";
 * import { fetchEligiblePlans } from "@features/membership/api/eligiblePlans";
 *
 * const { data, isLoading, error } = useQuery({
 *   queryKey: ["eligiblePlans"],
 *   queryFn: fetchEligiblePlans,
 * });
 * const plans = data?.results ?? [];
 */
